import React, { useEffect, useRef, useState } from "react";

import { isMobile } from "react-device-detect";

import MenuMobile from "../containers/MenuMobile";

import styles from "../../styles/layout.module.scss";

import { Drawer } from "../components/Drawer";

import NewOrder from "../containers/NewOrder";

import { useLocation, useNavigate } from "react-router";
import ring from "../../assets/mp3/ring.mp3";
import { OrderAPI } from "../../providers/OrderAPI";
import { Alert } from "../components/Alert";
import { EnvironmentStorage } from "../tools/EnvironmentStorage";
import { SSE } from "../utils/SSE";

import { OlgaOAuthAPI } from "@providers/OlgaOAuthAPI";
import ROLES from "data/Roles";
import { UserStorage } from "shared/tools/UserStorage";
import MenuDesktop from "shared/containers/MenuDesktop";
import { ToastContainer } from "react-toastify";
import { OlgaEnvironmentsAPI } from "providers/OlgaEnvironmentsAPI";
import { CashbackProgramAPI } from "providers/CashbackProgramAPI";

import classNames from "classnames/bind";
import { EnvironmentsAPI } from "providers/EnvironmentsAPI";
import GestorLogo from "shared/containers/GestorLogo";
import { InputSearch } from "shared/components/InputSearch";
import { If } from "shared/components/control-statements";
import { SelectActiveUnit } from "shared/containers/SelectActiveUnit";
import {
  DrawerTypes,
  StartMobileDrawer,
} from "shared/containers/Settings/StartMobileDrawer";
import { Button } from "@components";
import { Environment } from "shared/core/Environment";
import { AccessManager } from "shared/tools/AccessManager";
const css = classNames.bind(styles);

const useCustomInterval = (key, callback, eventName) => {
  const intervalId = useRef(null);

  useEffect(() => {
    const checkLocalStorageAndStartInterval = () => {
      const value = localStorage.getItem(key);

      if (value && !intervalId.current) {
        intervalId.current = setInterval(
          () => {
            callback();
          },
          1 * 60 * 1000,
        );
      } else if (!value && intervalId.current) {
        clearInterval(intervalId.current);
        intervalId.current = null;
      }
    };

    checkLocalStorageAndStartInterval();

    const eventListener = () => {
      checkLocalStorageAndStartInterval();
    };

    window.addEventListener(eventName, eventListener);

    return () => {
      if (intervalId.current) {
        clearInterval(intervalId.current);
        intervalId.current = null;
      }
      window.removeEventListener(eventName, eventListener);
    };
  }, [key, callback, eventName]);
};

export default function Layout({ children }) {
  const ringtone = new Audio(ring);

  const [muteRingtone, setMuteRingtone] = useState(false);
  const [openedOrders, setOpenedOrders] = useState([]);
  const [hasNewOrder, setHasNewOrder] = useState(false);
  const [snooze, setSnooze] = useState(false);
  const [ordersCount, setOrdersCount] = useState(0);
  const [reloadStoreStatus, setReloadStoreStatus] = useState(false);
  const [brands, setBrands] = useState([]);
  const [visible, setVisible] = useState(false);
  const [showDrawer, setShowDrawer] = useState(false);
  const [search, setSearch] = useState("");

  const loadOrders = async () => {
    const response = await OrderAPI.getOrders();
    const orders = response.getData({ items: { OPENED: [] } }).items.OPENED;
    const hasNewOrder = snooze ? false : orders.length > 0;
    setOpenedOrders(orders);
    setHasNewOrder(hasNewOrder);
    setOrdersCount(orders.length);

    if (!muteRingtone && hasNewOrder) {
      playAttempt();
    } else {
      ringtone.pause();
    }

    // if (!hasNewOrder) {
    //   window.dispatchEvent(new CustomEvent("ORDER_STATUS_CHANGED"));
    // }
  };

  const configurations = EnvironmentStorage.getConfigurations();

  useCustomInterval(
    `${configurations?.parent_alias}-refreshOrdersAuto`,
    loadOrders,
    "refreshOrdersAuto",
  );

  useEffect(() => {
    const configurations = EnvironmentStorage.getConfigurations();
    if (configurations && configurations.alias_path) {
      SSE.listen(
        `https://ntfy.sh/olga-food-${configurations.alias_path.replace(
          /\//g,
          "-",
        )}/sse`,
        loadOrders(),
      );
    }

    loadOrders();

    window.addEventListener("configurationUpdate", onUpdateConfiguration());

    return () => {
      window.removeEventListener(
        "configurationUpdate",
        onUpdateConfiguration(),
      );
    };
  }, []);

  const onUpdateConfiguration = () => {
    setReloadStoreStatus(!reloadStoreStatus);
  };

  const playAttempt = () => {
    const playAttemptId = setInterval(() => {
      ringtone
        .play()
        .then(() => {
          clearInterval(playAttemptId);
        })
        .catch((error) => {
          console.log("Unable to play the audio, User has not interacted yet.");
        });
    }, 1000);
  };

  const toggleSound = () => {
    setMuteRingtone(!muteRingtone);
    ringtone.volume = !muteRingtone;
  };

  const oldestOpenedOrderId =
    openedOrders.length > 0 ? openedOrders[openedOrders.length - 1].id : null;
  const displayId =
    openedOrders.length > 0
      ? openedOrders[openedOrders.length - 1].displayId
      : null;

  const isLogged = UserStorage.isLogged();

  const pathname = useLocation().pathname;

  const cdpPage = ["/", "/base-de-dados", "/cdp"].includes(pathname);

  const statusEnv = localStorage.getItem("status-environment");

  const isOnboarding =
    pathname.startsWith("/implantacao") || statusEnv === "ONBOARDING";

  useEffect(() => {
    if (
      pathname !== "/relatorios/marketing/campanhas" &&
      pathname !== "/configuracoes/cardapio/precos-e-skus"
    ) {
      const content = document.getElementById("content");
      content.style.overflowY = "auto";
    }
  }, [pathname]);

  useEffect(() => {
    const loadBrands = async () => {
      const brandsResponse = await OlgaEnvironmentsAPI.getBrands();
      const brands = brandsResponse.getData([]);

      setBrands(brands);
    };

    loadBrands();
  }, []);

  const loadCashbackProgram = async () => {
    const environment = EnvironmentStorage.getEnvironment();

    const user = UserStorage.getLoggedUser();

    const unitsResponse = await EnvironmentsAPI.getAvailableUnits(
      user.environment_id,
    );
    const units = unitsResponse.getData([]);
    const allBrands = Object.values(
      units.reduce((a, u) => ({ ...a, [u.brand.id]: u.brand }), {}),
    );

    const multimarcas = allBrands?.length > 1;

    const brand = brands.find((b) => b.name === environment.brand?.name);

    const response = await CashbackProgramAPI.getProgram(
      null,
      multimarcas ? brand?.id : null,
    );

    const program = response?.getData(null) || null;

    if (program) {
      localStorage.setItem("cashbackProgram", JSON.stringify(program));
      localStorage.setItem("cashbackProgramType", program.type);
    } else {
      localStorage.removeItem("cashbackProgram");
      localStorage.removeItem("cashbackProgramType");
    }
  };

  useEffect(() => {
    if (!brands.length) return;

    loadCashbackProgram();
  }, [brands]);

  useEffect(() => {
    window.addEventListener("CASHBACK_PROGRAM_UPDATE", () =>
      loadCashbackProgram(),
    );

    return () => {
      window.removeEventListener("CASHBACK_PROGRAM_UPDATE", () =>
        loadCashbackProgram(),
      );
    };
  }, []);

  const environment = EnvironmentStorage.getEnvironment();
  const isBrandSelected = environment?.type === "BRAND";
  const isUnitSelected =
    environment?.type !== "BRAND" && environment?.type !== "HOLDING";

  const isCiaTC = environment?.id === 811;

  const navigate = useNavigate();

  const mobileMenu = [
    {
      icon: "fal fa-gift",
      label: "Gerenciador de benefícios",
      drawer: DrawerTypes.BENEFIT_MANAGER,
      enabled: [
        ROLES.SUPPORT,
        ROLES.ADMIN,
        ROLES.MARKETING,
        ROLES.SAC,
      ].includes(UserStorage.getLoggedUser()?.role),
    },
    // {
    //   icon: "fal fa-user-edit",
    //   label: "Edição de clientes",
    //   drawer: "/beneficios",
    // },
    {
      icon: "fal fa-receipt",
      label: "Pedidos",
      link: "/pedidos",
      enabled: [
        ROLES.ADMIN,
        ROLES.SUPPORT,
        ROLES.MANAGER,
        ROLES.SHOPKEEPER,
        ROLES.SAC,
      ].includes(UserStorage.getLoggedUser()?.role),
    },
    {
      icon: "fal fa-clock",
      label: "Horário de atendimento",
      link: "/configuracoes/horarios-de-atendimento",
      enabled: [
        ROLES.ADMIN,
        ROLES.SUPPORT,
        ROLES.MANAGER,
        ROLES.SAC,
        ROLES.SHOPKEEPER,
      ].includes(UserStorage.getLoggedUser()?.role),
    },
    {
      icon: "fal fa-credit-card",
      label: "Pagamento na entrega",
      link: "/configuracoes/pagamento-na-entrega",
      enabled: [ROLES.ADMIN, ROLES.SUPPORT, ROLES.MANAGER, ROLES.SAC].includes(
        UserStorage.getLoggedUser()?.role,
      ),
    },
    {
      icon: "fal fa-eye-slash",
      label: "Ruptura de produtos no cardápio",
      drawer: DrawerTypes.SHUTDOWN_CATALOG,
      enabled: [
        ROLES.SUPPORT,
        ROLES.ADMIN,
        ROLES.MANAGER,
        ROLES.SHOPKEEPER,
      ].includes(UserStorage.getLoggedUser()?.role),
    },
    {
      icon: "fal fa-user-plus",
      label: "Liberar validação OTP",
      drawer: DrawerTypes.CONFIRM_LOGIN,
      enabled:
        [ROLES.SUPPORT, ROLES.ADMIN, ROLES.SAC].includes(
          UserStorage.getLoggedUser()?.role,
        ) || isCiaTC,
    },
    {
      icon: "fal fa-key",
      label: "Redefinição de senhas",
      drawer: DrawerTypes.RESET_PASSWORD,
      enabled: [ROLES.SUPPORT, ROLES.ADMIN, ROLES.SAC].includes(
        UserStorage.getLoggedUser()?.role,
      ),
    },
    {
      icon: "fal fa-ban",
      label: "Bloqueio de pedidos",
      drawer: DrawerTypes.BLOCKED_CUSTOMERS,
      enabled: [ROLES.SUPPORT, ROLES.ADMIN, ROLES.SAC].includes(
        UserStorage.getLoggedUser()?.role,
      ),
    },
  ];

  const filteredMenu = mobileMenu.filter((c) => {
    if (!c.enabled) return false;
    if (!search) return true;

    return !!search
      ? c.label?.toLowerCase().includes((search || "").toLowerCase())
      : true;
  });

  const allowedMobilePages = [
    "/pedidos",
    "/configuracoes/horarios-de-atendimento",
    "/configuracoes/pagamento-na-entrega",
  ];

  return (
    <>
      <If
        cond={
          isMobile &&
          isLogged &&
          !isOnboarding &&
          !allowedMobilePages.includes(pathname)
        }
      >
        <div className="mobileContainer">
          <p>Aplicação disponível via desktop.</p>
        </div>
      </If>

      <If cond={isMobile && isLogged && !isOnboarding && pathname === "/"}>
        <div className={styles.mobileMenu}>
          <div className={styles.header}>
            <div className={styles.welcome}>
              <div className={styles.logo}>
                <GestorLogo />
              </div>
              <p>Boas vindas</p>
            </div>

            <InputSearch
              placeholder="Buscar por..."
              design="two"
              onChange={(e) => setSearch(e.target.value)}
            />

            <div className={styles.selectUnit} onClick={() => setVisible(true)}>
              <div className="d-flex align-center">
                <div className={styles.logo}>
                  <If cond={environment?.brand?.avatarUrl}>
                    <img
                      src={
                        process.env.REACT_APP_ASSETS_URL +
                        `/` +
                        environment?.brand?.avatarUrl
                      }
                      alt={environment?.name}
                    />
                  </If>
                </div>
                <div className="d-flex flex-column">
                  <p className={styles.brand}>
                    {isUnitSelected
                      ? environment?.brand?.name
                      : environment?.name}
                  </p>
                  <If cond={isUnitSelected}>
                    <p className={styles.unit}>{environment?.name}</p>
                  </If>
                </div>
              </div>

              <div className={styles.vision}>
                <span className={styles.tag}>
                  <If cond={isBrandSelected}>VISÃO DE MARCA</If>
                  <If cond={isUnitSelected}>VISÃO DE UNIDADE</If>
                </span>
                <span className={styles.arrow}>
                  <i className="fas fa-chevron-right" />
                </span>
              </div>
            </div>

            <If cond={UserStorage.isGodMode}>
              <p className={styles.environment}>
                {isUnitSelected ? environment?.brand?.name : environment?.name}
              </p>
            </If>
          </div>

          <div className={styles.menuContainer}>
            <div className={styles.menu}>
              {filteredMenu.map((m) => (
                <div
                  key={m.label}
                  className={styles.item}
                  onClick={() => {
                    if (m.link) navigate(m.link);
                    else setShowDrawer(m.drawer);
                  }}
                >
                  <div className={styles.icon}>
                    <i className={m.icon} />
                  </div>
                  <div className={styles.label}>{m.label}</div>
                </div>
              ))}
            </div>
          </div>

          <div className={styles.footer}>
            <Button
              className="gap-10"
              onClick={() => {
                UserStorage.setAccessToken(null);
                EnvironmentStorage.setEnvironment(null);
                EnvironmentStorage.setConfigurations(null);
                Environment.uninstall();
                localStorage.removeItem("refreshOrdersAuto");
                localStorage.removeItem(
                  `${configurations?.parent_alias}-refreshOrdersAuto`,
                );
                AccessManager.setPermissions([]);
                navigate("/entrar");
              }}
            >
              <i className="fal fa-sign-out-alt" />
              <span>Sair</span>
            </Button>
          </div>
        </div>
      </If>

      <div
        className={css({
          layoutContainer: true,
          onboarding: isOnboarding,
        })}
        id="layout"
      >
        {!isMobile && isLogged && !isOnboarding && (
          <MenuDesktop ordersCount={ordersCount} />
        )}
        <div
          id="content"
          className={styles.content}
          style={{ paddingBottom: cdpPage ? 0 : "" }}
        >
          {children}
        </div>
        {/* {isMobile && isLogged && !isOnboarding && (
          <MenuMobile
            ordersCount={ordersCount}
            reloadStoreStatus={reloadStoreStatus}
          />
        )} */}

        {hasNewOrder && !snooze && (
          <Drawer
            visible={hasNewOrder}
            title={`Novo Pedido! (#${displayId})`}
            onClose={() => {
              ringtone.pause();
              setSnooze(true);

              setTimeout(() => {
                setSnooze(false);
                if (hasNewOrder) {
                  playAttempt();
                }
              }, 30000);
            }}
          >
            <NewOrder
              orderId={oldestOpenedOrderId}
              playing={!muteRingtone}
              toggleSound={toggleSound}
              onAcceptOrder={async (order) => {
                await OrderAPI.setStatus(oldestOpenedOrderId, "IN_PRODUCTION");
                window.dispatchEvent(new CustomEvent("orderAccepted"));
                loadOrders();
              }}
              onRejectOrder={async (order) => {
                await OrderAPI.setStatus(oldestOpenedOrderId, "REJECTED");
                loadOrders();
              }}
            />
          </Drawer>
        )}
        <Alert />
        <ToastContainer />

        <If cond={visible}>
          <SelectActiveUnit
            visible={visible}
            onClose={() => setVisible(false)}
            direction={isMobile ? "right" : "left"}
          />
        </If>

        {showDrawer && (
          <StartMobileDrawer
            visible={showDrawer}
            setting={showDrawer}
            onClose={() => setShowDrawer(false)}
          />
        )}
      </div>
    </>
  );
}
